import React from "react";
import { post } from "../utils/request";

class storeDetail extends React.Component {
    constructor(props) {
        super(...props);
        this.state = {
            urlOps: {},
            detailData: {},
        };
    }

    componentWillMount() {
        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = window.location.hash.split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }
        }

        this.setState(
            {
                urlOps: ops,
            },
            () => {
                this.getDetail();
            }
        );
    }

    getDetail() {
        const { urlOps } = this.state;
        post({
            url: `/gateway/rentalMall/shopcs/getShopDetail`,
            data: {
                shopCode: urlOps.shopCode,
                longitude: urlOps.longitude,
                latitude: urlOps.latitude,
                format: "GCJ02",
            },
            preventXXSKey: "shopContext",
        }).then(
            (res) => {
                if (res.result === "success" && res.data) {
                    this.setState({
                        detailData: res.data,
                    });
                }
            },
            (res) => {
                console.log("信息查询失败", res);
            }
        );
    }

    render() {
        const { detailData } = this.state;

        return (
            <div
                className="storeDetailBox"
                style={{ padding: "20px", boxSizing: "border-box" }}
            >
                <div
                    dangerouslySetInnerHTML={{ __html: detailData.shopContext }}
                />
            </div>
        );
    }
}

export default storeDetail;



// WEBPACK FOOTER //
// ./src/storeDetail/index.js